import { BAD_USER_INPUT, TOKEN_EXPIRED } from '@speeki/dictionary';
import { StorageManager } from '@speeki/storage-manager';

import { SetRecoveryEmailDocument } from '@graphql/generated/graphql';

import { useInitializeSession } from '@services/AuthService/useInitializeSession';

import { useMutation, useReactiveVar } from '@apollo/client';
import { sessionProcessingVar } from '@boot/reactiveVariables';

export const useSetupMfa = () => {
    const [setRecoveryEmail, { error, reset }] = useMutation(
        SetRecoveryEmailDocument,
        {
            context: {
                notifyOnError: {
                    exceptions: [BAD_USER_INPUT, TOKEN_EXPIRED],
                },
            },
            onCompleted: () => StorageManager.removeValue('metadata'),
            onError: () => {},
        },
    );
    const { initializeSession } = useInitializeSession(setRecoveryEmail, false);
    const setupMfaProcessing = useReactiveVar(sessionProcessingVar);

    return {
        cancelSetup: reset,
        handleSetup: initializeSession,
        setupError: error,
        setupMfaProcessing,
    };
};
